module.exports = __webpack_public_path__ + "static/media/triptodur-logo.084bd5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/triptodur-logo.png
// module id = 1378
// module chunks = 0